// Mesma estrutura de design tokens do Olavio (sistema-rh/src/App.js), com a paleta
// do Coren extraída da logo (azul), em vez do verde do Olavio.
export const COLORS = {
  primary: '#1d6bf0',
  primaryDark: '#0b3ddb',
  primaryBg: '#e8f1ff',
  accent: '#4fc3ff',
  danger: '#EF4444',
  dangerBg: '#FEF2F2',
  warning: '#F59E0B',
  warningBg: '#FFFBEB',
  info: '#1d6bf0',
  infoBg: '#e8f1ff',
  secondary: '#1d6bf0',
  white: '#FFFFFF',
  bg: '#EEF2F6',
  surface: '#FFFFFF',
  sidebar: 'rgba(255,255,255,0.96)',
  sidebarItem: 'rgba(29,107,240,0.07)',
  gray: '#F1F5F9',
  border: '#CBD5E1',
  borderFocus: '#1d6bf0',
  text: '#1A2332',
  textMid: '#475569',
  textLight: '#64748B',
  dark: '#1A2332'
};

export const FONT = "'Inter', system-ui, sans-serif";

export const RADIUS = { sm: 7, md: 10, lg: 14, card: 20 };

export const SHADOW = {
  card: '0 1px 3px rgba(30,41,59,0.05), 0 4px 16px rgba(30,41,59,0.07)',
  modal: '0 20px 60px rgba(15,23,42,0.15)',
  btnPrimary: '0 1px 4px rgba(29,107,240,0.25)'
};
